import _cloneDeep from 'lodash/cloneDeep';

/**
 * Merge tags from matterport and treedis
 * @param matterTags
 * @param treedisTags
 * @param threads
 * @param iotDevicesWithTags
 */
export const getAllTags = (
  matterTags,
  treedisTags,
  threads,
  iotDevicesWithTags,
): Map<string, any> => {
  const allTags: any = new Map();
  const matterTagsArray: any = [];

  matterTags.forEach((t: any) => {
    const index = treedisTags.findLastIndex((item: any) => t.sid === item?.sid);
    const found = index === -1 ? null : treedisTags[index];
    let media;
    if (t.media) {
      media = t.media;
    }

    const tag = Object.assign(_cloneDeep(found) || {}, {
      title: found && found.title && found.title.length ? found.title : t.label,
      positionX: found?.positionX ? found.positionX : t?.position?.x,
      positionY: found?.positionY ? found.positionY : t?.position?.y,
      positionZ: found?.positionZ ? found.positionZ : t?.position?.z,
      stemVectorX:
        found?.stemVectorX && found?.svXEnabled ? found.stemVectorX : t?.stem?.direction?.x || 0,
      stemVectorY:
        found?.stemVectorY && found?.svYEnabled ? found.stemVectorY : t?.stem?.direction?.y || 0.3,
      stemVectorZ:
        found?.stemVectorZ && found?.svZEnabled ? found.stemVectorZ : t?.stem?.direction?.z || 0,
      iconColor: found ? found.iconColor : t.color,
      opacity: found ? found.opacity : 100,
      mpTitle: found ? found.mpTitle : true,
      tooltip: found ? found.tooltip : true,
      mpNavigation: found ? found.mpNavigation : true,
      whiteCircle: found ? found.whiteCircle : false,
      transparentBackground: found ? found.transparentBackground : false,
      id: found?.id || t.sid || t.defaultSid,
      ...t,
      media,
      description: found?.description?.length ? found.description : t.description,
      customIcon: found ? found.customIcon : false,
    });

    if (found) {
      tag.modifiedTag = true;
      tag.processedInMatterTags = true;
    } else {
      matterTagsArray.push(tag);
    }

    if (index >= 0) {
      treedisTags[index] = tag;
    }
  });

  treedisTags.concat(matterTagsArray).forEach((tag: any) => {
    if (allTags.has(tag.sid)) {
      return;
    }

    const foundTagsWithDevice = iotDevicesWithTags?.filter(
      // eslint-disable-next-line eqeqeq
      (item) =>
        item.relatedAssets.find((asset) => asset.id == tag.sid) ||
        item.relatedAssets.find((asset) => asset.id == tag.defaultSid),
    );
    tag.iotDevices = foundTagsWithDevice;
    allTags.set(tag.sid, _cloneDeep(tag));
  });

  threads.forEach((thread: any) => {
    let media;
    if (thread.media) {
      media = thread.media;
    }

    const tag = Object.assign(_cloneDeep(thread) || {}, {
      title: thread.title,
      positionX: thread?.positionX,
      positionY: thread?.positionY,
      positionZ: thread?.positionZ,
      stemVectorX:
        thread?.stemVectorX && thread?.svXEnabled
          ? thread.stemVectorX
          : thread?.stem?.direction?.x || 0,
      stemVectorY:
        thread?.stemVectorY && thread?.svYEnabled
          ? thread.stemVectorY
          : thread?.stem?.direction?.y || 0.3,
      stemVectorZ:
        thread?.stemVectorZ && thread?.svZEnabled
          ? thread.stemVectorZ
          : thread?.stem?.direction?.z || 0,
      mpTitle: thread.mpTitle,
      tooltip: thread.tooltip,
      mpNavigation: true,
      whiteCircle: true,
      transparentBackground: false,
      id: thread.id,
      ...thread,
      media,
      description: thread.description,
      custom: true,
      customIcon: 'thread',
      stemVisible: true,
      isThread: true,
    });

    allTags.set(thread.sid, _cloneDeep(tag));
  });

  return allTags;
};
